<template>
  <div class="contactUs">
    <BreadsCrums page="contact" previous="home" />
    <section class="contact-info garden-set-pd-sm">
      <div class="container">
        <div class="title">
          <h3>{{ $t("ourInfo") }}</h3>
        </div>
        <div class="row">
          <div class="col-md-4 col-sm-4">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-map-marker"></span>
              </div>
              <div class="box-content">
                <h3>{{ $t("adress") }}</h3>
                <p>Cité Azimmo Ouaga 2000,</p>
                <p>11 BP 1597 Ouagadougou CMS</p>
                <p>11—Burkina Faso</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-envelope"></span>
              </div>
              <div class="box-content">
                <h3>{{ $t("email") }}</h3>
                <p>{{ contact_emailFr }}</p>
                <p>ekumi@afrikeveil.org</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-sm-4">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-phone"></span>
              </div>
              <div class="box-content">
                <h3>{{ $t("phone") }}</h3>
                <p>+226 25 66 64 60</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- <section class="contact-form garden-set-pd">
      <div class="container">
        <div class="box garden-form">
          <h3>SEND A MESSAGE</h3>
          <p>
            <span>*</span> field is required
          </p>
          <form action="#" method="post">
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xs-12 position-relative">
                <textarea
                  class="col-md-12 col-sm-12 col-xs-12"
                  name="message"
                  rows="7"
                  required="required"
                ></textarea>
                <p>
                  Message
                  <span>*</span>
                </p>
              </div>
              <div class="col-md-6 col-sm-12 col-xs-12 position-relative">
                <input
                  class="col-md-12 col-sm-12 col-xs-12"
                  type="text"
                  name="name"
                  required="required"
                />
                <p>
                  Your Name
                  <span>*</span>
                </p>
              </div>
              <div class="col-md-6 col-sm-12 col-xs-12 position-relative">
                <input
                  class="col-md-12 col-sm-12 col-xs-12"
                  type="email"
                  name="email"
                  required="required"
                />
                <p>
                  Your Email
                  <span>*</span>
                </p>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 position-relative none-mg">
                <div class="garden-button">
                  <a href="#">SEND MESSAGE</a>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>-->
    <section class="contact-info garden-set-pd-sm">
      <div class="container">
        <div class="row">
          <div class="col-md-3 col-sm-3">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-facebook"></span>
              </div>
              <div class="box-content">
                <h3>
                  <a :href="facebook">facebook</a>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-3">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-twitter"></span>
              </div>
              <div class="box-content">
                <h3>
                  <a :href="twitter">twitter</a>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-3">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-youtube"></span>
              </div>
              <div class="box-content">
                <h3>
                  <a :href="youtube">youtube</a>
                </h3>
              </div>
            </div>
          </div>
          <div class="col-md-3 col-sm-3">
            <div class="box">
              <div class="box-icon">
                <span class="fa fa-linkedin"></span>
              </div>
              <div class="box-content">
                <h3>
                  <a href="https://www.linkedin.com/company/afrik-eveil/">linkedin</a>
                </h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <Download
      :title="`${this.$i18n.t('facebookSendText')}`"
      link="https://m.me/afrikeveil.org"
      :buttonTitle="`${this.$i18n.t('facebookSend')}`"
    />
  </div>
</template>

<script>
import Axios from "axios";
import APPURL from "../constant";
export default {
  watch: {
    $route() {
      this.getInfo();
    }
  },
  created() {
    document.title = "Contact";
  },
  mounted() {
    this.getInfo();
  },
  computed: {
    contact_emailFr() {
      if (this.info[0]) {
        if (this.info[0].contact_emailFr) {
          return this.info[0].contact_emailFr;
        } else {
          return this.info[0].contact_emailEn;
        }
      }
      return "";
    },
    facebook() {
      if (this.info[0]) {
        return this.info[0].facebook;
      }
      return "";
    },
    twitter() {
      if (this.info[0]) {
        return this.info[0].twitter;
      }
      return "";
    },
    youtube() {
      if (this.info[0]) {
        return this.info[0].youtube;
      }
      return "";
    }
  },
  data() {
    return {
      info: {}
    };
  },
  name: "contact",
  methods: {
    getInfo(url = APPURL.LINK + "settings/" + this.$i18n.locale) {
      Axios.get(url).then(response => {
        this.info = response.data.data.results;
        // console.log(this.info[0]);
      });
    }
  }
};
</script>

<style scoped>
.box-content {
  text-transform: capitalize;
}
.box-content h3 a {
  color: #64a507;
  font-weight: bolder;
}
.box-content h3 a:hover {
  border-bottom: 2px solid #64a507;
}
</style>
